<template>
<div id="establishments-detail">
  <div v-if="error != null" class="row" id="establishments-detail-errors">
    <div class="col-xs-12 col-md-10 col-lg-8">
      <alert type="danger">
        <p>
          <strong>
            Attention ! Une erreur s'est produite pendant le chargement :
          </strong>
        </p>
        <p>
          {{ error }}
        </p>
      </alert>
    </div>
  </div>
  <div v-else>
    <router-view :config="config"
                 :surveillance="surveillance"
                 @nav="actions = $event" />
  </div>
</div>
</template>
<script>
import checkboxMenu from '@/components/checkboxMenu'
import cheatsheet from '@/components/sheet/add/cheatsheet'

import { mapGetters } from 'vuex'

export default {
  name: 'establishments-detail',

  props: {
    config: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      error: null
    }
  },

  computed: {
    ...mapGetters({
      get: 'surveillances/get',
      userId: 'user/id'
    }),

    surveillance: function () {
      return this.get(this.$route.params.year, this.$route.params.id)
    },

    type: function () {
      return this.$route.params.st
    },

    routePrefix: function () {
      const { year, id } = this.surveillance
      return `/establishments/${year}/${id}`
    },

    isRegistrator: function () {
      return this.surveillance.isRegistrator(this.userId)
    }
  },

  watch: {
    surveillance: function (value, old) {
      this.tab = 0
      if (value != null) {
        let load = false
        if (old == null || value.id !== old.id) {
          load = true
        } else {
          const vk = Object.keys(value.modules)
          const ok = Object.keys(old.modules)
          if (vk.length !== ok.length) {
            load = true
          } else {
            for (let i in vk) {
              if (ok.indexOf(vk[i]) === -1) {
                load = true
              }
            }
          }
        }
        if (load) {
          this.loadSheets()
        }
      }
    }
  },

  methods: {
    loadSheets: function () {
      if (this.surveillance != null) {
        const promises = [
          this.$store.dispatch('sheet/loadAll', this.surveillance)
        ]

        return Promise.all(promises).catch(e => {
          this.error = `Les données des fiches n'ont pu être récupérées, merci
de vérifier votre connexion internet avant de réessayer. Si le problème
persiste, veuillez contacter l'administrateur du site.`
        })
      }
    }
  },

  mounted: function () {
    if (this.surveillance == null) {
      this.$store.dispatch('surveillances/loadAll').then(response => {
        if (response.err != null) {
          this.error = `Les données de la surveillance n'ont pu être récupérées, merci
de vérifier votre connexion internet avant de réessayer. Si le problème
persiste, veuillez contacter l'administrateur du site.`
        } else if (this.surveillance == null) {
          this.error = `Surveillance inconnue : le serveur ne reconnaît pas
cette surveillance, merci de revenir à la page d'accueil des surveillances
pour en sélectionner une autre.`
        }
      })
    } else {
      this.loadSheets()
    }
  },

  components: {
    'checkbox-menu': checkboxMenu,
    'cheatsheet': cheatsheet
  }
}
</script>
<style lang="less">
@import '~variables';

#establishments-detail {
    min-height: 100rem;

    .jumbotron {
        background-color: darken(@base, 15%);
        padding-bottom: 3rem;
        margin-bottom: 0rem;
    }

    #establishment-nav {
        border-bottom: 1rem solid darken(@base, 15%);

        .navbar {
            background-color: darken(@base, 20%);
            margin-bottom: 0px;
            border-radius: 0px;
        }

        .navbar-separator {
            margin-left: 3rem;
            margin-right: 2rem;
        }
    }

    .progress {
        margin-bottom: 0rem;
    }

    .sheet-link {
        font-size: 90%;
    }

    .detail-checkbox {
        min-width: 25rem;
    }

    .selected-surveillance-type {
        .label {
            font-size: 120%;
            margin-top: 1.2rem;
            margin-bottom: 1rem;
        }
    }

    .action-button {
        padding-top: 0rem;
        span {
            font-size: 100%;
            vertical-align: top;
        }
        span.glyphicon {
            font-size: 140%;
        }
        span.key {
            font-size: 55%;
            opacity: 0.8;
            vertical-align: text-top;
        }

        a {
            padding-top: 0.7rem;
            padding-bottom: 0.5rem;
            margin-bottom: 0rem;
        }
        a:hover {
            color: lighten(@base, 20%);
        }
    }

    #establishments-detail-errors {
        margin: 2rem 1rem;
    }
}
</style>
